import Swiper from 'swiper/dist/js/swiper'
import defaultPreview from '../../modules/_defaultPreview';

const previewSlider = (wrapper) => {

  if (!wrapper) return;

  const sliderEl = wrapper.querySelector('.js-preview-slider');
  const pagination = wrapper.querySelector('.swiper-pagination');
  const slides = Array.prototype.slice.call(sliderEl.querySelectorAll('.swiper-slide'));
  const slidesLength = slides.length;
  const loop = slidesLength > 4;

  const options = {
    init: false,
    spaceBetween: 8,
    slidesPerView: 2,
    threshold: 6,
    speed: 150,
    preventInteractionOnTransition: true,
    loop,
    loopedSlides: slidesLength,
    autoHeight: true,
    updateOnImagesReady: true,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 3
    },
    pagination: {
      el: pagination,
      type: 'bullets',
      clickable: true,
    },
    on: {
      lazyImageReady() {
        setTimeout(() => {
          this.update();
        }, 500);
      },
      transitionStart() {
        sliderEl.classList.add('is-transition');
      },
      transitionEnd() {
        setTimeout(() => {
          sliderEl.classList.remove('is-transition');
        }, 200);
      },
    },
    breakpoints: {
      599: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1200: {
        slidesPerView: 2,
      }
    },
  };

  const slider = new Swiper(sliderEl, options);

  slider.on('init', () => {
    defaultPreview();
  });

  slider.init();

};
export default previewSlider;
